export { default as employeeListReducer } from './EmployeeList/reducer'
export { default as employeeImageReducer } from './EmployeeImage/reducer'
export { substitutesReducer, addNewSubstituteReducer } from './SubstituteSection/reducer'
export { default as user } from './Login/reducer'
